<template>
    <SliceZone :components="components" :slices="document?.data?.slices" :context="{parentDocument: document}" />
</template>

<script lang="ts" setup>
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {useResolvePrismicDocument} from '~/composables/content/useResolvePrismicDocument';
    import {useDocumentMetadata} from '~/composables/useDocumentMetadata';
    import {components} from '~/slices/components';

    const {data, error} = await useAsyncData('homepage', () => usePrismicDocument('resourcesCenterHome'));
    const document = useResolvePrismicDocument(data, error);

    if (document.value) {
        useDocumentMetadata(document.value);
    }

    useWebsitePageView('resources-center', 'homepage');
</script>
